import { useState, useEffect, useRef } from 'react'
import { GETPRODUCTLIST, DELETE_PRODUCT } from '../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import { AddProductModal } from './ProductModal/AddProductModal'
import plusIcon from '../../../../_metronic/images/smlplus.svg'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '../../../shared-css/Global.css'
import DownloadCsv from '../../Download/DownloadCsv'
import { alert } from '../../../../utils/helper'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import {
  PRODUCTLISTCONFIGS,
  SOLARPRODUCTLISTCONFIGS,
  filterDataFeedHelper,
  productFilterDataFeed,
} from '../../../../utils/TeamAdmin/ProductUtils'
import { dropdownMenuItemsType } from '../../../sharedComponent/SearchList/SearchList.types'
import { filterConfig } from '../../../../utils/Global.types'
import { GLOBAL_CONSTANTS } from '../../../../utils/GlobalConstants'
import { getProductDetailResponse } from '../../../../utils/GlobalAPI.types'
import Filter from '../../../sharedComponent/Filter'
import { useNavigate, useParams } from 'react-router-dom'

import UploadProducts from './UploadProducts'
import { SolarProductModal } from './ProductModal/SolarProductModal'
const MySwal = withReactContent(Swal)
// CSV file headers and key configuration
// Base headers common to all CSV types
const baseCsvHeaders = [
  { label: 'Product Name', key: 'productName' },
  { label: 'Product Code', key: 'productCode' },
]

// Extended headers shared by normal and dynamic CSVs
const commonProductHeaders = [
  { label: 'Commodity', key: 'commodity' },
  { label: 'Customer Type', key: 'customerType' },
  { label: 'Brand', key: 'brand' },
  { label: 'Billing Method', key: 'billingMethod' },
  { label: 'Adder', key: 'adder' },
  { label: 'Contract Type', key: 'contractType' },
  { label: 'Deposit', key: 'deposit' },
  { label: 'Service Fee', key: 'serviceFee' },
  { label: 'Termination Fee', key: 'terminationFee' },
  { label: 'Unit', key: 'unit' },
  { label: 'Utility', key: 'utility' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endDate' },
  { label: 'Product Status', key: 'isActive' },
  { label: 'Note 1', key: 'productNotes' },
  { label: 'TPV Script', key: 'tpvScriptStatus' },
]

// Final CSV header variants
const csvHeaders = [
  ...baseCsvHeaders,
  ...commonProductHeaders.slice(0, 3), // Adds Commodity, Customer Type, Brand, etc.
  { label: 'Rate', key: 'rate' },
  { label: 'Second Rate', key: 'secondRate' },
  ...commonProductHeaders.slice(3),
]

const dynamicCsvHeaders = [
  ...baseCsvHeaders,
  ...commonProductHeaders.slice(0, 3),
  { label: 'Minimum Rate', key: 'rateMinimum' },
  { label: 'Maximum Rate', key: 'rateMaximum' },
  { label: 'Rate', key: 'rate' },
  { label: 'Second Rate', key: 'secondRate' },
  { label: 'Minimum Term', key: 'termMinimum' },
  { label: 'Maximum Term', key: 'termMaximum' },
  { label: 'Term', key: 'term' },
  ...commonProductHeaders.slice(3),
]

const solarCsvHeaders = [...baseCsvHeaders]

//initial state for product list API payoad
const productInitialFilter = {
  page: 1,
  perPage: 10,
  searchText: '',
  isActive: null,
  tpvScriptStatus: null,
  utilityId: null,
  contractTypeId: null,
  customerTypeId: null,
}
const ProductList = ({
  filterData,
  getProductSetup,
  featureFlags,
  solarProduct,
}: {
  filterData: getProductDetailResponse
  getProductSetup: any
  featureFlags: any
  solarProduct?: any
}) => {
  const [createModal, setCreateModal] = useState<string>('create')
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false)
  const [productId, setProductId] = useState<any>()
  const [downloadData, setDownloadData] = useState<any>([])
  const [filterFeed, setFilterFeed] = useState<filterConfig[]>([])
  const [showUploadModal, setShowUploadModal] = useState(false)

  const csvRef = useRef<any>(null)
  //state for product list API payload
  const [filterOptions, setFilterOptions] = useState<any>(productInitialFilter)
  //to get product list
  const [getProductList, { loading, data: productList }] = useLazyQuery(GETPRODUCTLIST, {
    variables: {
      productListFilterInput: filterOptions,
    },
    onError: (err) => console.log('error', err),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  const getUrlParams = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (filterData?.getProductDetail?.length) {
      const filterDataFromApi: productFilterDataFeed[] = filterData?.getProductDetail
        .filter(
          (value) =>
            value.enum === 'UTILITY' ||
            value.enum === 'CONTRACT_TYPE' ||
            value.enum === 'CUSTOMER_TYPE'
        )
        .map((value) => ({
          enum: value.enum,
          names: value.names.map(({ id, value }) => ({ id, value })),
        }))
      const solarfilterDataFromApi: productFilterDataFeed[] = filterData?.getProductDetail
        .filter((value) => value.enum === 'UTILITY' || value.enum === 'CUSTOMER_TYPE')
        .map((value) => ({
          enum: value.enum,
          names: value.names.map(({ id, value }) => ({ id, value })),
        }))
      const selectedFilterData = solarProduct ? solarfilterDataFromApi : filterDataFromApi

      const filterDataTemp: productFilterDataFeed[] = [
        ...selectedFilterData,
        {
          enum: 'TPV_STATUS',
          names: [
            {
              id: 'ASSIGNED',
              value: 'Assigned',
            },
            {
              id: 'UNASSIGNED',
              value: 'Unassigned',
            },
          ],
        },
        {
          enum: 'PRODUCT_STATUS',
          names: [
            {
              id: GLOBAL_CONSTANTS.filterBooleanValue.true,
              value: 'Active',
            },
            {
              id: GLOBAL_CONSTANTS.filterBooleanValue.false,
              value: 'Inactive',
            },
          ],
        },
      ]
      //to set filter dropdown configuration state
      setFilterFeed(() =>
        filterDataTemp.map((value) => filterDataFeedHelper(value.names, value.enum))
      )
    }
  }, [filterData])// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getProductList()
  }, [filterOptions])// eslint-disable-line react-hooks/exhaustive-deps

  //Delete product
  const [deleteProduct] = useMutation(DELETE_PRODUCT, {
    onCompleted: (data) => {
      alert(data.removeProduct, 'success')
      getProductList()
    },
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: 'network-only',
  })
  const removePageProperties = (removePageFilterOptions: any) => {
    const { page, perPage, ...rest } = removePageFilterOptions
    return rest
  }
  // Product Download API  for CSV export file
  const [getProductCSVList, { loading: reload }] = useLazyQuery(GETPRODUCTLIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      productListFilterInput: removePageProperties(filterOptions),
      withDual: false,
    },
    onCompleted: async (data) => {
      const res = await data.getProductListByTeamAdmin.products
      setDownloadData(
        res.map((product: any) => ({
          ...product,
          utility: product.utility || product.gutility || '',
          gadder: product.adder || product.gadder || '',
          billingMethod: product.billingMethod || product.gbillingMethod || '',
          contractType: product.contractType || product.gcontractType || '',
          deposit: product.deposit || product.gdeposit || '',
          productCode: product.productCode || product.gproductCode || '',
          rate: product.rate || product.grate || '',
          rateMaximum: product.rateMaximum || product.grateMaximum || '',
          rateMinimum: product.rateMinimum || product.grateMinimum || '',
          secondRate: product.secondRate || product.gsecondRate || '',
          serviceFee: product.serviceFee || product.gserviceFee || '',
          term: product.term || product.gterm || '',
          termMaximum: product.termMaximum || product.gtermMaximum || '',
          termMinimum: product.termMinimum || product.gtermMinimum || '',
          terminationFee: product.terminationFee || product.gterminationFee || '',
          unit: product.unit || product.gunit || '',
          isActive: product.isActive ? 'Active' : 'Inactive',
        }))
      )
    },
    onError: (err) => console.log('error', err),
  })
  //to open product setup modal
  const openModal = (id: any, type?: string) => {
    console.log('id and type', id, type)
    const fetchedItems: any = []
    filterData?.getProductDetail
      ?.filter((item: any) => item.enum !== 'COMMODITY' && item.enum !== 'CUSTOMER_TYPE')
      .forEach((item: any) => {
        item.names.forEach((data: any) => fetchedItems.push(data))
      })

    if (fetchedItems === undefined || fetchedItems.length === 0) {
      MySwal.fire({
        icon: 'warning',
        title: 'Please Complete Product Setup before Adding a Product',
      })
    } else {
      setShowCreateAppModal(true)
      if (type === 'edit') {
        setCreateModal('edit')
        setProductId(id)
      } else if (type === 'Create') {
        setCreateModal(type)
        setProductId('')
      } else if (type === 'clone') {
        setCreateModal('clone')
        setProductId(id)
      }
    }
  }

  const handleCloseModal = () => {
    setShowCreateAppModal(false)
    setProductId('')
  }

  const csvDownloadFun = async () => {
    await getProductCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }
  //to open audit
  const openAudit = (id: any) => {
    navigate(`/${getUrlParams.adminUser}/product-audit`, {
      state: {
        itemId: id,
        itemType: 'Product',
      },
    })
  }
  //list dropdown configuration
  const dropdownMenuItems: dropdownMenuItemsType[] = [
    {
      name: 'Edit',
      callBack: openModal,
    },
    {
      name: 'Clone',
      callBack: openModal,
    },

    {
      name: 'Audit',
      callBack: openAudit,
    },
    {
      name: 'Delete',
      callBack: (id) =>
        deleteProduct({
          variables: {
            prodId: id,
          },
        }),
      textColor: 'text-danger',
    },
  ]
  //uploadproducts
  return (
    <SearchList
      filterOptions={filterOptions}
      setFilterOptions={setFilterOptions}
      apiData={productList?.getProductListByTeamAdmin?.products}
      listLoading={loading}
      listCount={productList?.getProductListByTeamAdmin?.totalCount}
      paginatedCount={productList?.getProductListByTeamAdmin?.product?.length}
      listConfigs={solarProduct ? SOLARPRODUCTLISTCONFIGS : PRODUCTLISTCONFIGS}
      idFieldName='prodId'
      isActiveApiFieldName=''
      dropdownMenuItems={dropdownMenuItems}
      onRowClick={(value: any) => openModal(value.prodId, 'edit')}
      toolbar={
        <>
          {!solarProduct && (
            <>
              <UploadProducts
                showModal={showUploadModal}
                setShowModal={setShowUploadModal}
                refetchProduct={getProductList}
                isProductListDynamic={
                  featureFlags?.getClientFeatureFlags?.enableDynamicProductCreation
                }
                isWelcomeScript={featureFlags?.getClientFeatureFlags?.enableWelcomeScriptFlow}
              />
              {productList?.getProductListByTeamAdmin?.totalCount !== 0 && (
                <DownloadCsv
                  csvDownloadFun={csvDownloadFun}
                  reload={reload}
                  csvHeaders={
                    solarProduct
                      ? solarCsvHeaders
                      : featureFlags?.getClientFeatureFlags?.enableDynamicProductCreation
                        ? dynamicCsvHeaders
                        : csvHeaders
                  }
                  csvRef={csvRef}
                  downloadData={downloadData}
                  downloadFileName='Products.csv'
                />
              )}
            </>
          )}
          <Filter
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            filterConfig={filterFeed}
            initialFilter={productInitialFilter}
          />
          {!solarProduct && (
            <button
              className='btn btn-primary fs-6 px-5 py-3 ms-5'
              onClick={(e) => openModal('', 'Create')}
            >
              <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
              <span>Add Product</span>
            </button>
          )}

          {solarProduct ? (
            <SolarProductModal
              show={showCreateAppModal}
              handleClose={handleCloseModal}
              method={createModal}
              editId={productId}
              refetchProduct={getProductList}
            />
          ) : (
            <AddProductModal
              show={showCreateAppModal}
              handleClose={handleCloseModal}
              method={createModal}
              editId={productId}
              refetchProduct={getProductList}
            />
          )}
        </>
      }
    />
  )
}
export default ProductList
